import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { collapsibleConfig, tokens } from '../../constants';
import { checkIsPlatform, fitContentWidth } from '../../utils';
export var getCollapsibleStyles = (props, isExpanded) => {
  var _a, _b, _c, _d, _e;
  var _props$titlePaddingTo = props.titlePaddingToken,
    titlePaddingToken = _props$titlePaddingTo === void 0 ? 'SPACING_16' : _props$titlePaddingTo,
    _props$childPaddingTo = props.childPaddingToken,
    childPaddingToken = _props$childPaddingTo === void 0 ? 'SPACING_16' : _props$childPaddingTo,
    _props$childNoVertica = props.childNoVerticalPadding,
    childNoVerticalPadding = _props$childNoVertica === void 0 ? false : _props$childNoVertica,
    _props$childNoHorizon = props.childNoHorizontalPadding,
    childNoHorizontalPadding = _props$childNoHorizon === void 0 ? false : _props$childNoHorizon,
    _props$titleNoVertica = props.titleNoVerticalPadding,
    titleNoVerticalPadding = _props$titleNoVertica === void 0 ? false : _props$titleNoVertica,
    _props$titleNoHorizon = props.titleNoHorizontalPadding,
    titleNoHorizontalPadding = _props$titleNoHorizon === void 0 ? false : _props$titleNoHorizon,
    version = props.version,
    expandedTitleContainerBgColor = props.expandedTitleContainerBgColor,
    expandedChildrenBgColor = props.expandedChildrenBgColor,
    allowAndroidAnimation = props.allowAndroidAnimation,
    showInfoTagOnCard = props.showInfoTagOnCard;
  var isFixedPadding = version == 'fixed-padding';
  var variableWidthStyles = {
    width: '100%',
    justifyContent: 'space-between'
  };
  var hasAnimatedView = allowAndroidAnimation || checkIsPlatform('ios');
  return StyleSheet.create({
    wrapper: Object.assign({}, showInfoTagOnCard && {
      borderTopLeftRadius: tokens.spacing.SPACING_0
    }),
    cardInfoTag: {
      marginLeft: tokens.spacing.SPACING_1
    },
    container: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, isFixedPadding && fitContentWidth()), !isFixedPadding && variableWidthStyles), !titleNoVerticalPadding && Object.assign({
      paddingVertical: (_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[titlePaddingToken]
    }, isExpanded && {
      paddingBottom: (_b = tokens === null || tokens === void 0 ? void 0 : tokens.spacing) === null || _b === void 0 ? void 0 : _b.SPACING_4
    })), !titleNoHorizontalPadding && {
      paddingHorizontal: (_c = tokens.spacing) === null || _c === void 0 ? void 0 : _c[titlePaddingToken]
    }), {
      flexDirection: 'row'
    }), expandedTitleContainerBgColor && isExpanded && {
      backgroundColor: expandedTitleContainerBgColor
    }),
    prefixIconName: {
      marginRight: tokens.spacing.SPACING_8
    },
    contentContainer: {
      flex: 1,
      flexDirection: 'column'
    },
    titleContainer: Object.assign(Object.assign({
      flexDirection: 'row'
    }, isFixedPadding && fitContentWidth()), !isFixedPadding && variableWidthStyles),
    title: {
      flex: 1
    },
    infoTag: {
      marginLeft: tokens.spacing.SPACING_4,
      marginVertical: tokens.spacing.SPACING_4
    },
    subTitle: {
      marginTop: tokens.spacing.SPACING_4
    },
    subTitleComponent: {
      marginTop: tokens.spacing.SPACING_8
    },
    iconContainer: {
      alignSelf: 'center',
      marginLeft: tokens.spacing.SPACING_4
    },
    contentContainerStyle: Object.assign(Object.assign({
      position: 'relative'
    }, expandedChildrenBgColor && isExpanded && {
      backgroundColor: expandedChildrenBgColor
    }), hasAnimatedView && {
      height: 0
    }),
    contentContainerBodyStyle: Object.assign(Object.assign({}, !checkIsPlatform('web') && {
      position: 'absolute',
      left: 0,
      top: 0
    }), {
      width: '100%'
    }),
    overflow: {
      overflow: 'hidden'
    },
    paddingContainer: Object.assign(Object.assign({}, !childNoHorizontalPadding && {
      paddingHorizontal: (_d = tokens.spacing) === null || _d === void 0 ? void 0 : _d[childPaddingToken]
    }), !childNoVerticalPadding && {
      paddingBottom: (_e = tokens.spacing) === null || _e === void 0 ? void 0 : _e[childPaddingToken]
    }),
    webContentVisibilityStyle: Object.assign({}, checkIsPlatform('web') && {
      visibility: isExpanded ? 'visible' : 'hidden'
    }),
    titleStyle: {
      flex: 1
    }
  });
};
export var getCollapsibleProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(collapsibleConfig === null || collapsibleConfig === void 0 ? void 0 : collapsibleConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.collapsible) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};